<template>
    <div class="form-check" :class="{'form-check-inline': dInline}">
        <input class="form-check-input" :name="name" :type="myType" :id="myId" :value="option" :checked="myChecked"
            @input="update" @change="update" :disabled="disabled">
        <label class="form-check-label" :for="myId" v-text="text"></label>
    </div>
</template>
<script>
    import uuid from '../../library/uuid';
    import translator from '../../library/data-translator';

    export default {
        props: {
            name: {
                default: null
            },
            checked: {
                default: false
            },
            dInline: {
                default: false
            },
            disabled: {
                default: false
            },
            id: {
                default: null
            },
            text: {
                required: true
            },
            type: {
                defualt: 'checkbox'
            },
            option: {
                default: null
            },
            value: {
                default: undefined
            }
        },
        watch: {
            value(newValue, oldValue) {
                this.myValue = newValue;
            }
        },
        data() {
            return {
                myValue: undefined,
                myId: null,
                myType: 'checkbox',
                uuid: uuid(),
                inited: false
            };
        },
        mounted() {
            this.myId = this.id
                ? translator.toDashString(this.id) + '-' + this.uuid
                : this.uuid;
            this.myType = ['checkbox', 'radio'].includes(this.type)
                ? this.type
                : this.myType;
            this.myValue = this.value;
            this.$nextTick(() => {
            });
        },
        computed: {
            myChecked() {
                if (this.type === 'checkbox') {
                    if (this.myValue instanceof Array)
                        return this.myValue.includes(this.option);
                    else {
                        return !!this.myValue;
                    }
                }
                if (this.type === 'radio') {
                    return (this.myValue === this.option);
                }
            }
        },
        methods: {
            update(e) {
                if (this.type === 'checkbox') {
                    if (this.myValue instanceof Array) {
                        if (e.target.checked && !this.myChecked) this.myValue.push(e.target.value);
                        if (!e.target.checked && this.myChecked) this.myValue.splice(this.myValue.indexOf(e.target.value), 1);
                        this.$emit(e.type, this.myValue);
                    } else {
                        this.myValue = e.target.checked;
                        this.$emit(e.type, this.myChecked);
                    }
                }
                if (this.type === 'radio') {
                    this.$emit(e.type, (e.target.value ? e.target.value : null));
                }
            }
        }
    }
</script>
<style lang="">

</style>